<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screen.screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="mx-2"
              color="primary"
              :disabled="!isAvailable"
              v-if="!screenReadOnlyFlag"
              >「新規登録」はこのボタンを押してください</v-btn
            >
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">操作権グループの新規登録</span>
            </v-card-title>
            <v-card-text class="card-authority-guide">
              <v-form ref="form" v-model="isPassedValid">
                <v-container fluid>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        label="操作権グループ名"
                        placeholder="入力してください"
                        outlined
                        :value="addGroupName"
                        :rules="[rules.required]"
                        v-bind="formControlProps(30)"
                        @blur="addGroupName = $event.target.value"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-radio-group v-model="copySelect">
                        <v-radio
                          :key="1"
                          :label="'他の操作権グループを複写'"
                          :value="1"
                        ></v-radio>
                        <p class="ml-10">
                          他の操作権グループに設定されている情報を複写する場合は、下のリストより選択してください
                        </p>
                        <v-col cols="6">
                          <v-select
                            v-model="copySourceList"
                            :items="[...opeAuthMst]"
                            :disabled="copyListDisable"
                            :filled="copyListDisable"
                            class="copy-source-list ml-10"
                            label="操作権グループ名"
                            item-text="ope_auth_gp_name"
                            item-value="ope_auth_gp_id"
                            placeholder="選択してください"
                            outlined
                            @change="copySelectedList"
                          >
                          </v-select>
                        </v-col>
                        <v-radio
                          :key="9"
                          :label="'新規に操作権グループを設定'"
                          :value="9"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <authority-guide />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="8" sm="8" md="8" lg="8">
                      <v-data-table
                        :headers="screenHeaders"
                        :items="screenItems"
                        :sort-by="['screenGroupId']"
                        :items-per-page="-1"
                        :height="328"
                        locale="ja-jp"
                        class="elevation-0"
                        hide-default-footer
                        item-key="screenGroupId"
                        dense
                      >
                        <template v-slot:[`item.screenGroupId`]="{ item }">
                          {{ item.screenGroupName }}
                        </template>
                        <template v-slot:[`item.operation_level`]="{ item }">
                          <v-select
                            v-model="item.operation_level"
                            :items="selectList[item.screenGroupId]"
                            dense
                            placeholder="選択してください"
                            item-text="mark"
                            item-value="operation_level"
                          >
                          </v-select>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mx-2"
                color="primary"
                @click="save"
                :disabled="!isPassedValid"
              >
                登録
              </v-btn>
              <v-btn class="mx-2" color="primary" @click="close()">
                キャンセル
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-overlay :value="dialogOverlay" opacity="1" color="white">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-dialog>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0;">
          操作権グループ毎に画面グループの操作権を設定します。<br />
          操作権情報は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <authority-guide @operationLevels="getOperationLevels" />
        <v-row>
          <v-col cols="6" md="4">
            <v-select
              v-model="operationAuthorityGroupNameFilterValue"
              :items="[...opeAuthMst]"
              label="操作権グループ"
              item-text="ope_auth_gp_name"
              item-value="ope_auth_gp_id"
              placeholder="選択してください"
              clearable
              outlined
            >
            </v-select>
          </v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>
        <template v-if="!screenReadOnlyFlag">
          <v-row>
            <v-col cols="12" class="text-right float-right">
              <v-btn
                class="mx-2"
                color="primary"
                @click="updateItems()"
                :disabled="isAvailable"
              >
                一括更新
              </v-btn>
              <v-btn
                class="mx-2"
                color="primary"
                @click="updateItems(true)"
                :disabled="isAvailable"
              >
                一括削除
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-right text-caption pb-0">
              <p class="mb-0">
                ※一覧でチェックをつけて編集した操作権グループを、一括で更新・削除できます。
              </p>
            </v-col>
          </v-row>
        </template>
      </v-container>
      <user-authorization-operation-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :sort-by="['ope_auth_gp_name']"
        :sort-desc="false"
        :show-select="!screenReadOnlyFlag"
        dispMode="nowrap"
        class="fixedWidth"
        item-key="ope_auth_gp_id"
        locale="ja-jp"
        must-sort
      >
        <template
          v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
        >
          <v-simple-checkbox
            :value="isSelected"
            @input="
              select($event);
              item.readonly_row = isSelected;
              changeCheckItem(item, isSelected);
            "
            :ripple="false"
          >
          </v-simple-checkbox>
        </template>
        <!-- 操作権グループ名 -->
        <template v-slot:[`item.ope_auth_gp_name`]="{ item }">
          <template v-if="!item.readonly_row">
            <a @click="openGroupNameDialog(item)">{{
              item.ope_auth_gp_name
            }}</a>
          </template>
          <template v-else>
            {{ item.ope_auth_gp_name }}
          </template>
        </template>
        <!-- トップ／メニュー -->
        <template v-slot:[`item.SFG001`]="{ item }">
          <v-select
            v-model="item.SFG001"
            :items="selectList['SFG001']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        災害名称管理
        <template v-slot:[`item.SFG002`]="{ item }">
          <v-select
            v-model="item.SFG002"
            :items="selectList['SFG002']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- OIL管理 -->
        <template v-slot:[`item.SFG003`]="{ item }">
          <v-select
            v-model="item.SFG003"
            :items="selectList['SFG003']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 住民向け広報管理 -->
        <template v-slot:[`item.SFG004`]="{ item }">
          <v-select
            v-model="item.SFG004"
            :items="selectList['SFG004']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- Lアラート管理 -->
        <template v-slot:[`item.SFG005`]="{ item }">
          <v-select
            v-model="item.SFG005"
            :items="selectList['SFG005']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- クロノロジー情報管理 -->
        <template v-slot:[`item.SFG006`]="{ item }">
          <v-select
            v-model="item.SFG006"
            :items="selectList['SFG006']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- ＱＲコード発行単位管理（要配慮者施設） -->
        <template v-slot:[`item.SFG007`]="{ item }">
          <v-select
            v-model="item.SFG007"
            :items="selectList['SFG007']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- ＱＲコード登録（要配慮者施設） -->
        <template v-slot:[`item.SFG008`]="{ item }">
          <v-select
            v-model="item.SFG008"
            :items="selectList['SFG008']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- ＱＲコード発行単位管理（学校） -->
        <template v-slot:[`item.SFG009`]="{ item }">
          <v-select
            v-model="item.SFG009"
            :items="selectList['SFG009']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- ＱＲコード登録（学校） -->
        <template v-slot:[`item.SFG010`]="{ item }">
          <v-select
            v-model="item.SFG010"
            :items="selectList['SFG010']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 仮ＱＲコード発行単位管理 -->
        <template v-slot:[`item.SFG011`]="{ item }">
          <v-select
            v-model="item.SFG011"
            :items="selectList['SFG011']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 仮ＱＲコード登録 -->
        <template v-slot:[`item.SFG012`]="{ item }">
          <v-select
            v-model="item.SFG012"
            :items="selectList['SFG012']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- バスＱＲコード印刷 -->
        <template v-slot:[`item.SFG013`]="{ item }">
          <v-select
            v-model="item.SFG013"
            :items="selectList['SFG013']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 安定ヨウ素剤配布状況一覧 -->
        <template v-slot:[`item.SFG014`]="{ item }">
          <v-select
            v-model="item.SFG014"
            :items="selectList['SFG014']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 安定ヨウ素剤事前配布状況個人検索 -->
        <template v-slot:[`item.SFG015`]="{ item }">
          <v-select
            v-model="item.SFG015"
            :items="selectList['SFG015']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- ユーザ情報管理 -->
        <template v-slot:[`item.SFG016`]="{ item }">
          <v-select
            v-model="item.SFG016"
            :items="selectList['SFG016']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 操作権管理 -->
        <template v-slot:[`item.SFG017`]="{ item }">
          <v-select
            v-model="item.SFG017"
            :items="selectList['SFG017']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 原子力災害関係施設マスタ管理 -->
        <template v-slot:[`item.SFG018`]="{ item }">
          <v-select
            v-model="item.SFG018"
            :items="selectList['SFG018']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 要配慮者施設マスタ管理 -->
        <template v-slot:[`item.SFG019`]="{ item }">
          <v-select
            v-model="item.SFG019"
            :items="selectList['SFG019']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 災害配信定型文マスタ管理 -->
        <template v-slot:[`item.SFG020`]="{ item }">
          <v-select
            v-model="item.SFG020"
            :items="selectList['SFG020']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 情報ガイドマスタ管理 -->
        <template v-slot:[`item.SFG021`]="{ item }">
          <v-select
            v-model="item.SFG021"
            :items="selectList['SFG021']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 避難所状況管理 -->
        <template v-slot:[`item.SFG022`]="{ item }">
          <v-select
            v-model="item.SFG022"
            :items="selectList['SFG022']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 避難者状況管理 -->
        <template v-slot:[`item.SFG023`]="{ item }">
          <v-select
            v-model="item.SFG023"
            :items="selectList['SFG023']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 施設状況管理（原子力災害関係） -->
        <template v-slot:[`item.SFG024`]="{ item }">
          <v-select
            v-model="item.SFG024"
            :items="selectList['SFG024']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 施設状況管理（要配慮者施設） -->
        <template v-slot:[`item.SFG025`]="{ item }">
          <v-select
            v-model="item.SFG025"
            :items="selectList['SFG025']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 防災関係者向け広報管理 -->
        <template v-slot:[`item.SFG026`]="{ item }">
          <v-select
            v-model="item.SFG026"
            :items="selectList['SFG026']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 地図表示 -->
        <template v-slot:[`item.SFG027`]="{ item }">
          <v-select
            v-model="item.SFG027"
            :items="selectList['SFG027']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- ログイン -->
        <template v-slot:[`item.SFG028`]="{ item }">
          <v-select
            v-model="item.SFG028"
            :items="selectList['SFG028']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 作業場所選択 -->
        <template v-slot:[`item.SFG029`]="{ item }">
          <v-select
            v-model="item.SFG029"
            :items="selectList['SFG029']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 入所退所QRコード読み込み -->
        <template v-slot:[`item.SFG030`]="{ item }">
          <v-select
            v-model="item.SFG030"
            :items="selectList['SFG030']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 避難者検索 -->
        <template v-slot:[`item.SFG031`]="{ item }">
          <v-select
            v-model="item.SFG031"
            :items="selectList['SFG031']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- バス乗車/降車登録 -->
        <template v-slot:[`item.SFG032`]="{ item }">
          <v-select
            v-model="item.SFG032"
            :items="selectList['SFG032']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- バス情報確認 -->
        <template v-slot:[`item.SFG033`]="{ item }">
          <v-select
            v-model="item.SFG033"
            :items="selectList['SFG033']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 安定ヨウ素剤配布QRコード読み込み -->
        <template v-slot:[`item.SFG034`]="{ item }">
          <v-select
            v-model="item.SFG034"
            :items="selectList['SFG034']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 安定ヨウ素剤配布状況 -->
        <template v-slot:[`item.SFG035`]="{ item }">
          <v-select
            v-model="item.SFG035"
            :items="selectList['SFG035']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 通知 -->
        <template v-slot:[`item.SFG036`]="{ item }">
          <v-select
            v-model="item.SFG036"
            :items="selectList['SFG036']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 設定 -->
        <template v-slot:[`item.SFG037`]="{ item }">
          <v-select
            v-model="item.SFG037"
            :items="selectList['SFG037']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 車両管理 -->
        <template v-slot:[`item.SFG038`]="{ item }">
          <v-select
            v-model="item.SFG038"
            :items="selectList['SFG038']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 防災資機材の配備状況取込 -->
        <template v-slot:[`item.SFG039`]="{ item }">
          <v-select
            v-model="item.SFG039"
            :items="selectList['SFG039']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 安定ヨウ素剤の事前配布状況取込 -->
        <template v-slot:[`item.SFG040`]="{ item }">
          <v-select
            v-model="item.SFG040"
            :items="selectList['SFG040']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 避難退域時検査場所状況表示 -->
        <template v-slot:[`item.SFG041`]="{ item }">
          <v-select
            v-model="item.SFG041"
            :items="selectList['SFG041']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- DPND連携 -->
        <template v-slot:[`item.SFG042`]="{ item }">
          <v-select
            v-model="item.SFG042"
            :items="selectList['SFG042']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 自治会マスタ -->
        <template v-slot:[`item.SFG043`]="{ item }">
          <v-select
            v-model="item.SFG043"
            :items="selectList['SFG043']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
        <!-- 調整システム -->
        <template v-slot:[`item.SFG044`]="{ item }">
          <v-select
            v-model="item.SFG044"
            :items="selectList['SFG044']"
            :disabled="screenReadOnlyFlag || item.readonly_row"
            dense
            placeholder="選択してください"
            item-text="mark"
            item-value="operation_level"
          >
          </v-select>
        </template>
      </user-authorization-operation-data-table>
    </v-sheet>
    <v-dialog v-model="groupNameDialog" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">操作権グループ名の編集</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="groupNameForm" v-model="groupNameValid">
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    :value="editGroupName"
                    label="操作権グループ名"
                    placeholder="入力してください"
                    outlined
                    :rules="[rules.required]"
                    v-bind="formControlProps(30)"
                    @blur="editGroupName = $event.target.value"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2"
            color="primary"
            @click="inputEditGroupName"
            :disabled="!groupNameValid"
          >
            選択
          </v-btn>
          <v-btn class="mx-2" color="primary" @click="close(true)">
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm-dialog ref="confirmMessageBox" />
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import FormUtils from "@/plugins/form-utils";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import AuthorityGuide from "@/components/user/AuthorityGuide";
import ConfirmDialog from "@/components/ConfirmDialog";
import { ScreenId } from "@/js/value-objects/screen-id";
import messageUtils from "@/mixins/message-utils";
import {
  selectList,
  screenIdGroupList,
  getRepresentScreenId
} from "@/js/constants/screen-operation";

Vue.use(FormUtils);

const opeAuthMstRepository = RepositoryFactory.get("opeAuthMst");
const opeauthgpMstRepository = RepositoryFactory.get("opeauthgpMst");
const systemInfoRepository = RepositoryFactory.get("systemInfo");

export default {
  mixins: [messageUtils],

  components: {
    ConfirmDialog,
    AuthorityGuide,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    UserAuthorizationOperationDataTable: () =>
      import("@/components/ui/UserAuthorizationOperationDataTable")
  },

  data: () => ({
    errors: null,
    overlay: false,
    dialogOverlay: false,
    dialog: false,
    groupNameDialog: false,
    screenReadOnlyFlag: false,
    items: [],
    opeAuthMst: [],
    opeauthgpMst: [],
    screens: [],
    screenItems: [],
    selectList: selectList(),
    operationLevels: [],
    opeAuthGpId: "",
    selected: [],
    editGroupRow: {},
    editGroupName: "",
    addGroupName: "",
    operationAuthorityGroupNameFilterValue: "",
    copySelect: 9,
    copyListDisable: true,
    copySourceList: "",
    groupNameValid: false,
    isPassedValid: false,
    editedItems: {},
    screen: null,
    rules: {
      required: value => (!!value && /\S/.test(value)) || "必須項目です。"
    }
  }),

  computed: {
    headers() {
      return this.makeHeaders();
    },

    screenHeaders() {
      return [
        {
          text: "画面グループ名",
          value: "screenGroupId",
          sortable: false,
          width: 300
        },
        {
          text: "操作権限",
          value: "operation_level",
          sortable: false,
          width: 205
        }
      ];
    },

    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(this.screenReadOnlyFlag, counter);
      };
    },

    // 編集ボタン制御
    isAvailable: function() {
      // 編集モードかつチェック項目が0でない場合はdisabled=false
      if (!this.screenReadOnlyFlag && this.selected.length > 0) {
        return false;
      } else {
        return true;
      }
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    groupNameDialog(val) {
      val || this.close(true);
    },
    // 新規登録ダイアログのラジオボタン制御
    copySelect(val) {
      if (val) {
        // 複写する
        if (val === 1) {
          // 複写元のセレクトボックスを非活性
          this.copyListDisable = false;
        } else {
          // 複写しない
          // 複写元のセレクトボックスを初期化＆非活性
          this.copySourceList = "";
          this.copyListDisable = true;
          // テーブルの初期化
          this.screenItems = cloneDeep(screenIdGroupList);
        }
      }
    },
    $route: "initialize"
  },

  created() {
    this.initialize();
  },

  mounted() {
    this.pageTitle(this.screen.screenTitle);
  },
  methods: {
    async initialize(savedFlg = false) {
      this.overlay = true;

      this.screen = this.$screenOperationAuthority(
        ScreenId.SF1204,
        ScreenId.SF1208
      );
      this.screenReadOnlyFlag = this.screen.readOnly;
      // 編集権限ある場合は、新規登録ダイアログの表示に必要なデータ取得
      if (!this.screenReadOnlyFlag && !savedFlg) {
        this.screenItems = cloneDeep(screenIdGroupList);
      }
      // DPND連携リスト取得（DBのシステムマスタTBより取得）
      await systemInfoRepository
        .list(this.screen.screenId, "AUTHORIZE_DPND")
        .then(response => {
          const res = response.data.results;
          //  key順に並び替え
          res.sort(function(a, b) {
            return a.key - b.key;
          });
          // DPND連携用のセレクトボックスリストを生成
          res.forEach(list => {
            const listVal = {
              mark: list.value2,
              operation_level: list.value
            };
            this.selectList["SFG042"].push(listVal);
          });
        })
        .catch(e => {
          this.handleError(e, this.screen.screenId, "aggregation-menu");
        });
      await opeAuthMstRepository
        .list(this.screen.screenId)
        .then(response => {
          this.opeAuthMst = response.data.results;
          // １．画面グループIDとグループ代表画面IDを取得
          const representScreenIdList = getRepresentScreenId();
          // 取得した操作権情報を画面グループID別の操作権に整形
          this.opeAuthMst.forEach(item => {
            // 未選択行はdisableに
            item.readonly_row = true;
            // ２．「１」で取得したリストの値が操作権リストに存在するかチェック
            representScreenIdList.forEach(list => {
              // 画面G名「トップ/メニュー」はauth_leve:1を固定値とする
              if (list.screenGroupId === "SFG001") {
                item[list.screenGroupId] = "1";
              } else {
                let res = "";
                res = item.ope_auth_list.find(
                  val => val.manage_id === list.representScreenId
                );
                if (res) {
                  /**
                   * 「２」のチェックでtrueなら
                   * 「１」の結果に操作レベルを画面グループIDをキーとして値にセット
                   */
                  item[list.screenGroupId] = res.ope_auth_level;
                } else {
                  /**
                   * 「２」のチェックでfalseなら
                   * 「１」の結果に画面グループIDをキーとして操作権レベルの初期値をセット
                   */
                  item[list.screenGroupId] = "14";
                }
              }
            });
          });
          this.items = cloneDeep(this.opeAuthMst);
        })
        .catch(e => {
          this.handleError(e, this.screen.screenId, "aggregation-menu");
        });
      this.overlay = false;
      this.dialogOverlay = false;
    },

    async updateItems(isDelete = false) {
      // リクエスト中の削除フラグ
      let deleteFlg = "0";

      // 一括削除の場合
      if (isDelete) {
        // 一括削除確認ダイアログ表示
        const firstDeleteMessage = "選択された操作権グループを削除しますか？";
        if (!(await this.deleteItemConfirm(firstDeleteMessage))) {
          return false;
        }
        const secondDeleteMessage =
          "削除した場合には元に戻せません。本当によろしいですか？";
        if (!(await this.deleteItemConfirm(secondDeleteMessage))) {
          return false;
        }
        // 削除フラグを書き換える
        deleteFlg = "1";
      } else {
        // 一括更新の場合
        // 一括更新確認ダイアログ表示
        const updateMessage = "選択された操作権グループを更新しますか？";
        if (!(await this.updateItemConfirm(updateMessage))) {
          return false;
        }
      }
      // 画面毎操作権限 更新
      const opeAuthList = [];
      this.selected.forEach(item => {
        let opeAuthGroupInfo = {};
        let screenAuthList = [];
        opeAuthGroupInfo.ope_auth_gp_id = item.ope_auth_gp_id;
        opeAuthGroupInfo.ope_auth_gp_name = item.ope_auth_gp_name;
        opeAuthGroupInfo.delete_flg = deleteFlg;
        opeAuthGroupInfo.hash = item.hash;
        // 画面グループIDごとの情報を画面IDごとに変換
        screenIdGroupList.some(list => {
          list.belongsScreenIdList.some(val => {
            let res = {};
            res.manage_id = val; //画面ID
            res.manage_cls = "1"; //管理区分（１：画面、２：API）※ここは「１」で固定。「２」はもう使われてない？
            res.ope_auth_level = item[list.screenGroupId];
            screenAuthList.push(res);
            /**
             * 削除処理の場合、無駄なループを止める。
             * 1件だけ残すのは、API側でこの配列内の値の必須チェックがあるため
             */
            if (isDelete) {
              return true;
            }
          });
          if (isDelete) {
            return true;
          }
        });
        opeAuthGroupInfo.ope_auth_list = screenAuthList;
        opeAuthList.push(opeAuthGroupInfo);
      });
      const payload = {
        ope_auth_gp_list: opeAuthList
      };
      this.clearMessage();
      this.overlay = true;
      await opeAuthMstRepository
        .update(ScreenId.SF1208, payload)
        .then(response => {
          this.handleSuccess(response);
          // 更新処理が成功時のみ画面再描画＆セレクト解除
          this.initialize(true);
          this.$nextTick(() => {
            this.selected = [];
          });
        })
        .catch(error => {
          this.handleUpdateError(error);
        });
      this.overlay = false;
    },
    // 一括削除確認ダイアログ呼び出し
    deleteItemConfirm(message) {
      return this.$refs.confirmMessageBox.open(message, "削除");
    },
    // 一括更新ダイアログ呼び出し
    updateItemConfirm(message) {
      return this.$refs.confirmMessageBox.open(message, "更新");
    },
    // 登録確認ダイアログ呼び出し
    registItemConfirm(message) {
      return this.$refs.confirmMessageBox.open(message, "登録");
    },
    // 新規登録ダイアログを閉じる処理
    close(groupNameDialogFlg = false) {
      if (groupNameDialogFlg) {
        // バリデーションエラーのリセット
        this.$refs.groupNameForm.resetValidation();
        // フォーム入力値をリセット
        this.editGroupName = "";
        this.editGroupRow = {};
        this.groupNameDialog = false;
      } else {
        // バリデーションエラーのリセット
        this.$refs.form.resetValidation();
        // ラジオボタンの選択内容とコピー元操作権グループセレクトボックスの初期化
        this.copySourceList = "";
        this.copySelect = 9;
        // ダイアログ中のテーブルの初期化
        this.screenItems = cloneDeep(screenIdGroupList);
        // 操作権グループ名の入力値初期化
        this.addGroupName = "";
        // ダイアログ閉じる
        this.dialog = false;
      }
    },
    // 新規登録処理
    async save() {
      // 登録処理確認ダイアログ表示
      const registMessage = "操作権グループを登録しますか？";
      if (!(await this.registItemConfirm(registMessage))) {
        return false;
      }
      if (this.$refs.form.validate() === false) {
        return;
      }
      this.dialogOverlay = true;
      this.clearMessage();
      // 操作権グループ情報 登録
      const payload1 = {
        ope_auth_gp_name: this.addGroupName
      };
      // 操作権グループの新規登録（ここでope_auth_gp_idをAPIレスポンスから取得）
      const opeauthgpResult = await opeauthgpMstRepository
        .create(ScreenId.SF1205, payload1)
        .then(response => {
          this.handleSuccess(response);
          // 新規登録した操作権グループのID取得
          this.opeAuthGpId = response.data.results[0].ope_auth_gp_id;
        })
        .catch(e => {
          this.handleCreateError(e);
          return "ERROR";
        });
      // 操作権グループの登録が成功した場合のみ登録処理を続ける
      if (opeauthgpResult !== "ERROR") {
        // 画面毎操作権限 登録
        const screenIdInfolist = [];
        this.screenItems.forEach(screenItem => {
          // 画面グループIDごとの情報を画面IDごとに変換
          screenItem.belongsScreenIdList.forEach(sId => {
            let screenIdInfo = {};
            screenIdInfo.manage_id = sId;
            screenIdInfo.manage_cls = "1";
            screenIdInfo.ope_auth_level = screenItem.operation_level;
            screenIdInfolist.push(screenIdInfo);
          });
        });
        const payload2 = {
          ope_auth_gp_id: this.opeAuthGpId,
          ope_auth_list: screenIdInfolist
        };
        await opeAuthMstRepository
          .create(ScreenId.SF1205, payload2)
          .then(response => {
            this.handleSuccess(response);
          })
          .catch(error => {
            this.handleCreateError(error);
          });
      }
      this.addGroupName = "";
      this.opeAuthGpId = "";
      await this.close();
      await this.initialize(true);
    },

    // 検索処理（操作権グループ名）：操作権グループIDがキー
    operationAuthorityGroupNameFilter(value) {
      if (!this.operationAuthorityGroupNameFilterValue) {
        return true;
      }
      return value === this.operationAuthorityGroupNameFilterValue;
    },

    // 権限の凡例を生成
    getOperationLevels(operationLevels) {
      this.operationLevels = operationLevels;
    },

    // 一覧表のヘッダー生成
    makeHeaders() {
      let headers = [];
      const opeGroupId = {
        text: "フリーテキスト",
        align: " d-none",
        value: "ope_auth_gp_id",
        filter: this.operationAuthorityGroupNameFilter
      };
      const opeGroupName = {
        text: "操作権グループ名",
        value: "ope_auth_gp_name",
        width: 500
      };
      headers.push(opeGroupId);
      headers.push(opeGroupName);
      Object.keys(this.selectList).map(groupID => {
        let items = {
          text: screenIdGroupList.find(
            ({ screenGroupId }) => screenGroupId === groupID
          ).screenGroupName,
          value: groupID,
          sortable: false
        };
        headers.push(items);
      });
      return headers;
    },
    // チェックボックスのチェック時・解除時の入力内容制御
    changeCheckItem(item, isPreSelected) {
      /**
       * チェックボックスをチェック時に、編集前の値を保存。
       * チェックボックスのチェック解除時に、編集前の値を復元。
       */
      if (isPreSelected) {
        // チェック解除時
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].ope_auth_gp_id === item.ope_auth_gp_id) {
            // readonly_row:入力の可否を管理している変数はそのままだと入力可能となるので、変更
            this.editedItems[item.ope_auth_gp_id].readonly_row = true;
            this.$set(
              this.items,
              i,
              cloneDeep(this.editedItems[item.ope_auth_gp_id])
            );
            delete this.editedItems[item.ope_auth_gp_id];
            break;
          }
        }
      } else {
        // チェック時
        this.editedItems[item.ope_auth_gp_id] = cloneDeep(item);
      }
    },
    // 新規登録時の既存操作権グループのコピー処理
    copySelectedList() {
      // 選択された既存操作権グループの情報を取得
      const original = this.items.find(
        val => val.ope_auth_gp_id === this.copySourceList
      );
      this.screenItems.forEach(item => {
        this.$set(item, "operation_level", original[item.screenGroupId]);
      });
    },
    openGroupNameDialog(item) {
      this.editGroupRow = item;
      this.editGroupName = item.ope_auth_gp_name;
      this.groupNameDialog = true;
    },
    // 操作権グループ名の編集
    inputEditGroupName() {
      if(this.$refs.groupNameForm.validate() === false) {
        return false;
      }
      this.items.some(item => {
        if (item.ope_auth_gp_id === this.editGroupRow.ope_auth_gp_id) {
          this.$set(item, "ope_auth_gp_name", this.editGroupName);
          return true;
        }
      });
      this.close(true);
    }
  }
};
</script>
<style scoped>
.input {
  border: 0;
  width: 100%;
}
</style>
